import { InsuranceAreaDTO } from '@/types/api-types';

import { INSURANCE_AREA } from '@/constants/global-constants';

export const getInsuranceObjectIdFromInsuranceAreaId = (
  insuranceAreaId: InsuranceAreaDTO['uuid'],
) => {
  return insuranceAreaId
    .replace(`${INSURANCE_AREA.INSURANCE}_`, '')
    .replace(`${INSURANCE_AREA.SETTLEMENT}_`, '');
};
